import type { InjectionKey } from "vue";
import type { MonitoringApi } from "./monitoring-api";
import type { WebSocketService } from "./web-socket-service";

export const API_SYMBOL: InjectionKey<MonitoringApi> = Symbol();
export const WS_SYMBOL: InjectionKey<WebSocketService> = Symbol();
